export default __webpack_public_path__ + "d1f3782145dc2a66bf296d1bf0ee4c82.png";